<template>
    <div class="hello">
        <h1>{{ title }}</h1>

        <div class="spacer-small"></div>

        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="teams">
            <table>
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th class="kgk-left">Team</th>
                        <th style="white-space:nowrap">Anzahl Läufe</th>
                        <th>Gelaufene Schritte</th>
                        <th>Gelaufene Kilometer</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(team, index) in teams"
                        :key="team.identifier">
                        <td>
                            <div class="kgk-mobile-th">Platzierung:</div>
                            <span class="kgk-ranking-num">{{ index + 1 }}.</span>
                        </td>
                        
                        <td class="kgk-left">
                            <div class="kgk-mobile-th kgk-left">Team:</div>
                            {{ team.team_name }}
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Anzahl Läufe:</div>
                            {{ team.number_of_runs }}
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Gelaufene Schritte:</div>
                            <strong>{{  convertNumberReadable(team.total_steps,2) }}</strong>
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Gelaufene Kilometer:</div>
                            <strong>{{ convertNumberReadable(team.total_steps_multiplied,2) }} km</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else-if="error">
            <p>Fehler: {{error}}</p>
        </div>
    </div>
</template>

<script>
    import leaderboard from '../../api/leaderboard';

    export default {
        name: 'LeaderboardCompanyGroupSteps',
        props: {
            title: {
                type: String,
                required: false,
                default: 'Rangliste der internen Firmenteams',
            },
            all: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
                teams: null,
                loading: false,
                error: null,
                company_name:'',
            }
        },
        computed: {
            
        },
        methods: {

        },

        mounted() {
            this.loading = true;

            leaderboard.getStepsGroupCompany(
                this,
                this.all,
                data => {
                    this.teams = data.teams;
                    //this.company_name = data[0].company_name;
                },
                () => this.error = 'Es ist ein Fehler aufgetreten',
                () => this.loading = false,
            );
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped lang="scss">
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
</style>-->
